import React, { useEffect, useState } from 'react';
import { Container, Grid } from '@exxonmobil/react-unity';
import { useParams } from 'react-router-dom';
import MainCard from '../common/components/MainCard';
import PageTitle from '../common/components/PageTitle';
import { useDomainDetailApi } from './hooks/useApi';
import NotFound from '../common/components/NotFound';
import DomainVolumeChart from '../trends/components/DomainVolumeChart';
import { useAxiosRequestWithParams, useGetClient } from '../common/utils/withTokenClient';
import { INSTANT_FIRST_DAY_OF_THE_YEAR, INSTANT_TODAY } from '../common/date';
import OverviewTile from './components/OverviewTile';
import UtilizationTable from './components/UtilizationTable';
import ServicesTable from './components/ServicesTable';
import { useEndpointsApi } from '../endpoints/hooks/useApi';

const ServicesTableTitleList = ['Service Name', 'Current status'];
const UtilizationTableTitleList = [
  'Service Name',
  // 'Service Technical Name',
  'Type',
  // 'Method',
  // 'Endpoint Name',
  'Source',
  'Number Of Consumer',
  'Consumer',
  'Consumer Volume(YTD)'
];

const Detail = () => {
  const { id } = useParams();
  const [startDateTime] = useState(INSTANT_FIRST_DAY_OF_THE_YEAR);
  const [endDateTime] = useState(INSTANT_TODAY);

  const { data: domains, isLoading: domainsIsLoading } = useGetClient('domains');
  // const [domain, setDomain] = useState<DomainValidation | null>();

  // useEffect(() => {
  //   if (!domainsIsLoading && domains) {
  //     const domain = domains.filter((domain) => domain.id === id);
  //     setDomain(domain || null);
  //   }
  // }, [domains, domainsIsLoading]);

  const {
    data: endpoints,
    error: endpontsError,
    isLoading: endpointsIsLoading,
    fetch: fetchEndpoints
  } = useEndpointsApi();

  const {
    data: domainDetail,
    error,
    isLoading: domainDetailIsLoading,
    fetch: fetchDomainDetail
  } = useDomainDetailApi(id || '');

  const {
    data: volume,
    error: volumeError,
    isLoading: volumeIsLoading,
    token: volumeToken,
    fetch: volumeFetch
  } = useAxiosRequestWithParams();

  const volumeFetchApi = () => {
    volumeFetch({
      api: `trends/volume/${id}?startTime=${startDateTime}&endTime=${endDateTime}`,
      payload: null,
      method: 'GET'
    });
  };

  useEffect(() => {
    volumeFetchApi();
  }, [startDateTime, endDateTime, id, volumeToken]);

  const domainName = domainDetail?.domainName || '';
  const services = domainDetail?.services || [];
  const processes = domainDetail?.processes || [];
  const isSLA = processes.length !== 0 ? 1 : 0;
  const components = isSLA ? processes : services;
  const NOT_FOUND_MESSAGE = 'Domain id not found.';

  if (error === '404') {
    return <NotFound errorMessage={NOT_FOUND_MESSAGE} />;
  }

  return (
    <>
      <PageTitle title={domainName} isLoading={domainDetailIsLoading} />
      <Container>
        <OverviewTile domains={domains || []} isLoading={domainsIsLoading} />
        <Grid>
          <Grid.Item>
            <MainCard
              title=""
              kicker={isSLA ? 'Service Availability (SLA)' : 'Service Availability'}
              footer={
                <ServicesTable
                  components={components}
                  isLoading={domainDetailIsLoading}
                  error={error}
                  titles={ServicesTableTitleList}
                  onRefresh={fetchDomainDetail}
                />
              }
            />
          </Grid.Item>
          <Grid.Item>
            <MainCard
              title=""
              kicker="Volume Trends (YTD)"
              icon=""
              footer={
                <DomainVolumeChart
                  data={
                    volume || {
                      dates: [],
                      apiUsage: [],
                      eventUsage: []
                    }
                  }
                  isLoading={volumeIsLoading}
                  error={volumeError}
                  onRefresh={volumeFetchApi}
                />
              }
            />
          </Grid.Item>
        </Grid>
        <UtilizationTable
          data={endpoints || []}
          isLoading={endpointsIsLoading}
          error={endpontsError}
          titles={UtilizationTableTitleList}
          onRefresh={fetchEndpoints}
        />
      </Container>
    </>
  );
};

export default Detail;
